export const BASE_SCORE_PER_CORRECT = 75
export const STREAK_BONUS_STEP = 5

export function scoreForCorrect(streakBeforeAnswer: number): number {
  return BASE_SCORE_PER_CORRECT + Math.max(0, streakBeforeAnswer) * STREAK_BONUS_STEP
}

export function explainScoring(): string {
  return `Score = (${BASE_SCORE_PER_CORRECT} + streak×${STREAK_BONUS_STEP}) × category multiplier`
}
